import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AngularMaterialModule } from 'src/app/external-components/angular-material.module';
import { CommonModule } from '@angular/common';
import { DevextremeModule } from 'src/app/external-components/devextreme.module';
import { FlexLayoutModule } from 'ng-flex-layout';
import { NgModule } from '@angular/core';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { ExecutionQEditComponent} from './execution-q-edit.component';
import { QuillModule } from 'ngx-quill';
import { SharedModule } from '../../shared/shared.module';

import { ExecutionQEditTestComponent } from './execution-q-edit-test/execution-q-edit-test.component';
import { ExecutionEditEquipmentDialogComponent } from './execution-edit-q-equipment-dialog/execution-edit-q-equipment-dialog.component';
import { ExecutionEditTestAttachmentsComponent } from './execution-edit-test-attachments/execution-q-edit-test-attachments.component';
import { ExecutionQEditAttachmentsComponent } from './execution-q-edit-attachments/execution-q-edit-attachments.component';
import { ExecutionEditQValidateExecutionComponent } from './execution-edit-q-validate-execution/execution-edit-q-validate-execution.component';
import { ExecutionEditQDeviationComponent } from './execution-edit-q-deviation/execution-edit-q-deviation.component';
import { ExecutionEditQDeviationListComponent } from './execution-edit-q-deviation-list/execution-edit-q-deviation-list.component';
import { ExecutionQEditConfirmSaveComponent } from './execution-edit-q-confirm-save/execution-edit-q-confirm-save.component';
import { ExecutionQEditBioindicatorsDetailsComponent } from './execution-q-edit-bioindicators-details/execution-q-edit-bioindicators-details.component';
import { ExecutionQEditConfigSensorComponent } from './execution-q-edit-config-sensor/execution-q-edit-config-sensor.component';
import { ExecutionQEditCopyEssayComponent } from './execution-q-edit-copy-essay/execution-q-edit-copy-essay.component';
import { ExecutionQEditEssayCriteriaComponent } from './execution-q-edit-essay-criteria/execution-q-edit-essay-criteria.component';
import { ExecutionQEditDefrostListComponent } from './execution-q-edit-defrost-list/execution-q-edit-defrost-list.component';
import { ExecutionQEditDialogCorrectSensorComponent } from './execution-q-edit-dialog-correct-sensor/execution-q-edit-dialog-correct-sensor.component';
import { ExecutionQEditDiscardTimeComponent } from './execution-q-edit-discard-time/execution-q-edit-discard-time.component';
import { ExecutionQEditGraphComponent } from './execution-q-edit-graph/execution-q-edit-graph.component';
import { ExecutionQEditEssayComponent } from './execution-q-edit-essay/execution-q-edit-essay.component';
import { ExecutionQEditEssayFieldComponent } from './execution-q-edit-essay-field/execution-q-edit-essay-field.component';
import { ExecutionQEditEssayBottomSheetUploadComponent } from './execution-q-edit-essay-bottom-sheet-upload/execution-q-edit-essay-bottom-sheet-upload.component';
import { ExecutionQEditAttachmentDetailsComponent } from './execution-q-edit-attachment-details/execution-q-edit-attachment-details.component';
import { ExecutionEditQTestObservationsComponent } from './execution-edit-q-test-observations/execution-edit-q-test-observations.component';
import { ExecutionQEditReasonExpositionTimeComponent } from './execution-q-edit-reason-exposition-time/execution-q-edit-reason-exposition-time.component';
import { ExecutionQEditTestInstrumentalUsedComponent } from './execution-q-edit-test-instrumental-used/execution-q-edit-test-instrumental-used.component';
import { ExecutionQEditAuditComponent } from './execution-edit-q-audit/execution-edit-q-audit.component';
import { ExecutionQEditTestCriticalInstrumentationComponent } from './execution-q-edit-test-critical-instrumentation/execution-q-edit-test-critical-instrumentation.component';
import { ExecutionQEditGenerateReportComponent } from './execution-q-edit-generate-report/execution-q-edit-generate-report.component';
import {  ExecutionEditQAuditListQFilterComponent } from './execution-edit-q-audit/execution-edit-q-audit-list-filter.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { ExecutionQEditEssayMassiveUploadComponent } from './execution-q-edit-essay-massive-upload/execution-q-edit-essay-massive-upload.component';


@NgModule({
  declarations: [
    ExecutionQEditComponent, ExecutionEditEquipmentDialogComponent,
    ExecutionQEditTestComponent,ExecutionQEditAttachmentsComponent,
    ExecutionQEditAuditComponent,
    ExecutionEditTestAttachmentsComponent, ExecutionEditQValidateExecutionComponent, ExecutionEditQDeviationComponent,ExecutionEditQDeviationListComponent,
    ExecutionQEditConfirmSaveComponent, ExecutionQEditBioindicatorsDetailsComponent, ExecutionQEditConfigSensorComponent, ExecutionQEditCopyEssayComponent,
    ExecutionQEditEssayCriteriaComponent, ExecutionQEditDefrostListComponent, ExecutionQEditDialogCorrectSensorComponent, ExecutionQEditDiscardTimeComponent,
    ExecutionQEditGraphComponent, ExecutionQEditEssayComponent, ExecutionQEditEssayFieldComponent, ExecutionQEditEssayBottomSheetUploadComponent, ExecutionQEditAttachmentDetailsComponent,
    ExecutionEditQTestObservationsComponent, ExecutionQEditReasonExpositionTimeComponent, ExecutionQEditTestInstrumentalUsedComponent, ExecutionQEditTestCriticalInstrumentationComponent,
    ExecutionQEditGenerateReportComponent,ExecutionEditQAuditListQFilterComponent, ExecutionQEditEssayMassiveUploadComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    QuillModule.forRoot(),
    MatExpansionModule,

    /* Custom modules */
    AngularMaterialModule,
    DevextremeModule,
    SharedModule,
    PipesModule,
    

    /* Otros */
    FlexLayoutModule
  ]
})
export class ExecutionQEditModule { }
